export enum LogConsts {
  ERROR = 'ERROR',
  WARNING = 'WARNING',
  INFO = 'INFO',
}
